function formsOnPage() {
  return document.querySelectorAll('form');
}

function elementsToDisable(parent) {
  return parent.querySelectorAll('[data-disable-with]');
}

function newSpinnerElement() {
  const elem = document.createElement('div');
  elem.setAttribute('class', 'spinner-border spinner-border-sm me-1');
  elem.setAttribute('role', 'status');
  elem.innerHTML = '<span class="visually-hidden">Loading...</span>';

  return elem;
}

function overlaySpinnerElement() {
  const elem = document.createElement('div');
  elem.setAttribute('class', 'position-absolute top-50 start-50 translate-middle');
  elem.appendChild(newSpinnerElement());

  return elem;
}

const disableButtonLikeElement = (element) => {
  element.setAttribute('data-enable-with', element.innerHTML);
  const disableWithValue = element.getAttribute('data-disable-with');

  if (disableWithValue === 'false') {
    return;
  }

  let spinnerElement;

  switch (disableWithValue) {
    case '':
      element.innerHTML = `<span style="visibility: hidden">${element.innerHTML}</span>`;
      element.style.position = 'relative';
      spinnerElement = overlaySpinnerElement();
      break;

    case 'true':
      break;

    default:
      element.innerHTML = disableWithValue;
      break;
  }

  spinnerElement ??= newSpinnerElement();
  element.prepend(spinnerElement);
};

const disabler = {
  input: (element) => {
    if (element.hasAttribute('value')) {
      element.setAttribute('data-enable-with', element.getAttribute('value'));
      element.setAttribute('value', element.getAttribute('data-disable-with'));
    }
    element.disabled = true;
  },
  button: (element) => {
    disableButtonLikeElement(element);
    element.disabled = true;
  },
  a: (element) => {
    disableButtonLikeElement(element);
    element.classList.add('disabled', 'text-muted');
    element.setAttribute('aria-disabled', 'true');
    element.setAttribute('tabindex', '-1');
    element.style.pointerEvents = 'none';
  },
};

const enableButtonLikeElement = (element) => {
  if (element.hasAttribute('data-enable-with')) {
    element.innerHTML = element.getAttribute('data-enable-with');
  }
};

const enabler = {
  input: (element) => {
    if (element.hasAttribute('value') && element.hasAttribute('data-enable-with')) {
      element.setAttribute('value', element.getAttribute('data-enable-with'));
    }
    element.disabled = false;
  },
  button: (element) => {
    enableButtonLikeElement(element);
    element.disabled = false;
  },
  a: (element) => {
    enableButtonLikeElement(element);
    element.classList.remove('disabled', 'text-muted');
    element.removeAttribute('aria-disabled');
    element.removeAttribute('tabindex');
    element.style.pointerEvents = 'auto';
  },
};

const disableElement = (element) => {
  const tagName = element.tagName.toLowerCase();
  const disableFunction = disabler[tagName];

  if (disableFunction) {
    disableFunction(element);
  }
};

const enableElement = (element) => {
  const tagName = element.tagName.toLowerCase();
  const enableFunction = enabler[tagName];

  if (enableFunction) {
    enableFunction(element);
  }
};

function reEnableDisabledElements() {
  elementsToDisable(document).forEach(enableElement);
}

function pageShouldNotBFCache() {
  return document.querySelectorAll('[data-no-bfcache]').length > 0;
}

function setupFormSubmissions() {
  formsOnPage().forEach((form) => {
    // Skip if already set up to avoid duplicate event listeners
    if (form.dataset.formSubmissionSetup === 'true') {
      return;
    }

    form.addEventListener('submit', (event) => {
      // Is this timeout weird? Yes. It is.
      // See: https://github.com/Gusto/gws-flows/pull/1072
      window.setTimeout(() => {
        elementsToDisable(event.target).forEach(disableElement);
      }, 13);
    });

    // Mark as set up to avoid duplicate listeners
    form.dataset.formSubmissionSetup = 'true';
  });

  document.querySelectorAll('[data-spinner-on]').forEach((target) => {
    // Skip if already set up to avoid duplicate event listeners
    if (target.dataset.spinnerSetup === 'true') {
      return;
    }

    target.addEventListener(target.dataset.spinnerOn, function spin() {
      target.removeEventListener(target.dataset.spinnerOn, spin);
      const parent = target.parentElement;
      const replaceElementsSelector = target.dataset.replaceElementSelector;
      const toReplace = replaceElementsSelector && parent.querySelector(replaceElementsSelector);

      parent.insertBefore(newSpinnerElement(), toReplace || target);

      if (toReplace) {
        toReplace.parentElement.removeChild(toReplace);
      }
    });

    // Mark as set up to avoid duplicate listeners
    target.dataset.spinnerSetup = 'true';
  });
}

// Initial setup on DOMContentLoaded
document.addEventListener('DOMContentLoaded', setupFormSubmissions);

// Re-setup after Turbo page loads (for full page refreshes)
document.addEventListener('turbo:load', setupFormSubmissions);

// Re-setup after Turbo renders (for partial updates)
document.addEventListener('turbo:render', setupFormSubmissions);

// Re-enable form elements after Turbo submission completes
document.addEventListener('turbo:submit-end', () => {
  reEnableDisabledElements();
});

// If any element on the page should not allow the
// bfcache to persist it's value, force a page reload.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    reEnableDisabledElements();
  }
  if (event.persisted && pageShouldNotBFCache()) {
    window.location.reload();
  }
});

export { reEnableDisabledElements, disableElement, enableElement };
